<script setup>

import MediaFilterType from './MediaFilterType.vue';

const props = defineProps({
    filters: {
        type: Object,
    },
})

const selectedFilters = defineModel('selectedFilters');

</script>

<template>
    <div class="m-locations-media-filters">
        <MediaFilterType
					v-for="(filter, key) in filters"
					:key="key"
					:filter="filter"
					:filterKey="key"
					v-model:selectedFilters="selectedFilters"
				/>
    </div>
</template>